/**
 * The clients module's routes, owned by the feature. D5.
 *
 * The paths stay `/users` and `/users/:id` even though the feature is `clients`: they are what the
 * sidebar links to and what any bookmarked URL holds. Renaming the route is a redirect question,
 * not a file-layout one.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const ClientsPage = lazy(() => import('./ClientsPage'));
const ClientProfile = lazy(() => import('./ClientProfile'));

export const clientsRoutes: RouteObject[] = [
    { path: 'users', element: <ClientsPage /> },
    { path: 'users/:id', element: <ClientProfile /> },
];
